export default function CourseCard({ category, name, desciprion, image, setSelectedCategory }) {
    const thumbnail = Boolean(image) ? image : "/images/course-thumb.jpg"
    return (
        <>
            <div class="card-container courseCard" onClick={() => setSelectedCategory(category)} style={{ cursor: "pointer" }}>
                <div class="card p-3">

                    <div class="card-content">
                        <h3 class="card-title text-center" style={{ height: "50px" }}>{name}</h3>
                        <div class="card-image p-1">
                            <img className='cat-img' src={thumbnail} alt="Course Thumbnail"
                                onError={(e) => {
                                    e.target.src = "/images/course-thumb.jpg"
                                }}
                            />
                        </div>

                        <hr />
                        <div className='card-desciption-content'>
                            <p class="card-description">
                                {desciprion}
                            </p>
                        </div>

                    </div>
                </div>
            </div>
        </>
    )
}
